<div class="modal-content email-send-dialog">
  <div class="modal-header">
    <p class="modal-title">
      <strong>{{ 'COMMON_BUTTON_EMAIL' | translate }}</strong>
    </p>
    <button type="button" class="close" (click)="dialogRef.close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <form [formGroup]="emailSendForm" (ngSubmit)="sendEmail()" novalidate>
    <div class="modal-body">
      <mat-dialog-content style="overflow: visible">
        <div class="row form-group"
             [ngClass]="{ 'has-danger': emailSendForm.controls['recipientName'].touched && !emailSendForm.controls['recipientName'].valid}">
          <div class="col-md-4">
            <label class="col-form-label mw-100 form-control-label">{{'COMMON_RECIPIENT_NAME' | translate}}</label>
          </div>
          <div class="col-md-8">
            <input type="text" class="form-control" placeholder="{{'COMMON_RECIPIENT_NAME' | translate}}"
                   [(ngModel)]="emailSendModel.recipientName"
                   [ngClass]="{ 'form-control-danger': emailSendForm.controls['recipientName'].touched && !emailSendForm.controls['recipientName'].valid}"
                   formControlName="recipientName"
                   maxlength="{{UiConstants.maximumVarcharLength}}">
            <div class="form-control-feedback"
                 *ngIf="emailSendForm.controls['recipientName'].touched && !emailSendForm.controls['recipientName'].valid">
              {{'COMMON_VALIDATION_MESSAGE_REQUIRED' | translate}}
            </div>
          </div>
        </div>

        <div class="row form-group"
             [ngClass]="{ 'has-danger': emailSendForm.controls['recipientEmailAddress'].touched && !emailSendForm.controls['recipientEmailAddress'].valid}">
          <div class="col-md-4">
            <label class="col-form-label mw-100 form-control-label">{{'COMMON_RECIPIENT_EMAIL' | translate}}</label>
          </div>
          <div class="col-md-8">
            <input type="text" class="form-control" placeholder="{{'COMMON_RECIPIENT_EMAIL' | translate}}"
                   formControlName="recipientEmailAddress"
                   [(ngModel)]="emailSendModel.recipientEmailAddress"
                   [ngClass]="{ 'form-control-danger': emailSendForm.controls['recipientEmailAddress'].touched && !emailSendForm.controls['recipientEmailAddress'].valid}"
                   maxlength="{{UiConstants.maximumVarcharLength}}">
            <div class="form-control-feedback"
                 *ngIf="emailSendForm.controls['recipientEmailAddress'].touched && !emailSendForm.controls['recipientEmailAddress'].valid">
              {{'COMMON_VALIDATION_MESSAGE_EMAIL' | translate}}
            </div>
          </div>
        </div>

        <div class="alert mb-0"
             [ngClass]="{ 'alert-danger': emailSendModel.isDangerous(), 'alert-info': !emailSendModel.isDangerous()}">
          <h6 class="alert-title">{{'CLIENT_DOCUMENT_SEND_EMAIL_NOTIFICATION' | translate: {
            count:
            emailSendModel.generalPdfIds.length
          } }}</h6>
        </div>
      </mat-dialog-content>
    </div>

    <div class="modal-footer">
      <button type="submit" class="btn btn-primary">
        {{'COMMON_BUTTON_EMAIL' | translate}}
      </button>
      <button type="button" class="btn btn-secondary" (click)="dialogRef.close()">
        {{'COMMON_BUTTON_CANCEL' | translate}}
      </button>
    </div>
  </form>
</div>
